import {rest} from 'msw'
const data = require('../data/field-settings.json')

export default [
  /**
   * プラント情報
   */
  rest.get('/swc-api/nodes/:nodeId/field-settings', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    const key = req.params.nodeId === '2' ? '2' : req.params.nodeId === '3' ? '3' : '1'
    return res(
      ctx.status(200),
      ctx.json(data[key])
    )
  })
]
